import materialList from '../pages/reading_material/materialList.vue';
import createMaterial from '../pages/reading_material/createMaterial.vue';
import editMaterial from '../pages/reading_material/editMaterial.vue';

const routes = [
  { // /materials
    path: '/materials',
    name: 'material-list',
    component: materialList,
    meta:{
      name: 'Materials',
      requireAuth: true
    },
  },
  { // materials/new
    path: 'materials/new',
    name: 'new-material',
    component: createMaterial,
    meta:{
      name: 'Create Material',
      requireAuth: true
    },
  },
  { // materials/:id
    path: 'materials/:id',
    name: 'edit-material',
    component: editMaterial,
    meta:{
      name: 'Edit Material',
      requireAuth: true
    },
    props: true
  },
]

export default routes